import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { GroupSelectOption } from '../group-select.component';

@Component({
  selector: 'rma-group-select-option',
  imports: [NgTemplateOutlet, NgClass],
  templateUrl: './group-select-option.component.html',
  host: {
    '[class]': 'hostClass',
    '[attr.aria-checked]': 'ariaChecked',
    '(click)': 'onClick()',
    '(keydown.enter)': 'onEnter()',
  },
})
export class GroupSelectOptionComponent<T extends GroupSelectOption> {
  @Input()
  optionTemplate: TemplateRef<unknown> | null = null;

  @Input()
  option!: T;

  @Input()
  public get disabled(): boolean {
    return this._disabled;
  }
  public set disabled(value: BooleanInput) {
    this._disabled = coerceBooleanProperty(value);
    this.hostClass = value ? 'cursor-not-allowed' : 'cursor-pointer';
  }

  @Output()
  readonly optionChange = new EventEmitter<{ option: T; selected: boolean }>();

  hostClass = 'cursor-pointer';
  ariaChecked = false;

  public get selected(): boolean {
    return this._selected;
  }
  public set selected(value: BooleanInput) {
    this._selected = coerceBooleanProperty(value);
    this.ariaChecked = this._selected;
  }

  private _selected = false;
  private _disabled = false;

  onClick() {
    this.onSelected();
  }

  onEnter() {
    this.onSelected();
  }

  private onSelected() {
    if (!this.disabled) {
      this.optionChange.emit({ option: this.option, selected: !this.selected });
    }
  }
}
